import { LoaderProps } from '../Loader.types';

export type PropsHelper =
  | { heightInRem: number }
  | { size: 'xsmall' | 'small' | 'medium' | 'large' };

export interface AdapterLoaderProps {
  /**
   * @deprecated use `size` instead using the following values :
   * - xsmall: 0.75rem
   * - small : 2rem
   * - medium : 4rem
   * - large : 6rem
   */
  heightInRem?: number;
  /**
   * @deprecated darkMode corresponds to variant secondary
   */
  darkMode?: boolean;

  size?: 'xsmall' | 'small' | 'medium' | 'large';
  variant?: 'primary' | 'secondary';
  className?: string;
}

export const isNewLoaderProps = (props: AdapterLoaderProps): boolean =>
  Boolean((props as LoaderProps).size);
